<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/showcase"></ion-back-button>
        </ion-buttons>
        <ion-title>Управление событиями</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="$router.push('/admin-events/new')">
            <ion-icon :icon="addOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <div class="ion-padding">
        <p v-if="loading" class="ion-text-center">Загрузка...</p>
        <ion-list v-else lines="full">
          <ion-item
            v-for="ev in events"
            :key="ev.id"
            button
            @click="$router.push(`/admin-events/${ev.id}/registrations`)"
          >
            <img
              :src="ev.logoPath ? eventsService.logoUrl(ev.logoPath) : defaultEventLogo"
              slot="start"
              class="event-logo"
              :alt="ev.title"
            />
            <ion-label>
              <h2>{{ ev.title }}</h2>
              <p>{{ formatDate(ev.startAt) }}</p>
              <span v-if="ev.deletedAt" class="event-badge event-badge-deleted">Удалено</span>
              <span v-else-if="ev.published === false" class="event-badge event-badge-draft">Черновик</span>
            </ion-label>
            <ion-button fill="clear" slot="end" @click.stop="$router.push(`/admin-events/${ev.id}/edit`)">
              <ion-icon :icon="createOutline" class="admin-event-edit-icon"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { addOutline, createOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { ILigaEvent } from '@/model/liga-event.model';
import eventsService from '@/services/events.service';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'AdminEventsList',
  components: {
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonTitle,
    IonToolbar
  },
  data() {
    return {
      events: [] as ILigaEvent[],
      loading: true,
      headerScrolled: false,
      eventsService,
      defaultEventLogo: require('@/theme/liga-logo-white.png'),
      addOutline,
      createOutline
    };
  },
  async mounted() {
    await this.load();
  },
  ionViewWillEnter() {
    this.load();
  },
  methods: {
    onContentScroll(e: CustomEvent) {
      const scrollTop = e.detail?.scrollTop ?? 0;
      this.headerScrolled = scrollTop > 16;
    },
    async load() {
      this.loading = true;
      try {
        this.events = await eventsService.getEvents(true);
      } catch (e) {
        this.events = [];
      }
      this.loading = false;
    },
    formatDate(iso: string) {
      return dayjs(iso).format('D MMM YYYY, HH:mm');
    }
  }
});
</script>

<style scoped>
.event-logo {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 12px;
}
ion-item {
  --background: rgba(42, 42, 42, 0.6);
  --color: #fff;
  --border-color: rgba(255, 255, 255, 0.1);
}
ion-item h2,
ion-item p {
  color: #fff;
}
.event-badge {
  display: inline-block;
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 6px;
  vertical-align: middle;
}
.event-badge-draft {
  background: rgba(255, 193, 7, 0.3);
  color: #ffc107;
}
.event-badge-deleted {
  background: rgba(244, 67, 54, 0.3);
  color: #f44336;
}
.admin-event-edit-icon {
  color: #fff !important;
  --color: #fff !important;
}
</style>
